// Named custom easings for the animation engine. Presets reference them by NAME
// (`transition.ease: "bounceOut"`) because preset objects are persisted in
// Redux/course JSON, where functions would not survive serialization.

// Classic drop-and-bounce (Penner bounceOut): lands at t≈0.36, then two
// smaller bounces. Used by "Bounce" (Zıpla) on the y axis.
export const bounceOut = (t) => {
  const n1 = 7.5625;
  const d1 = 2.75;
  if (t < 1 / d1) return n1 * t * t;
  if (t < 2 / d1) {
    const u = t - 1.5 / d1;
    return n1 * u * u + 0.75;
  }
  if (t < 2.5 / d1) {
    const u = t - 2.25 / d1;
    return n1 * u * u + 0.9375;
  }
  const u = t - 2.625 / d1;
  return n1 * u * u + 0.984375;
};

// Back-out with a strong (~20%) overshoot — "pop" into place. Used by
// "Bounce In" on scale so it reads differently from Zıpla's vertical drop.
export const backOutStrong = (t) => {
  const c1 = 2.6;
  const c3 = c1 + 1;
  const u = t - 1;
  return 1 + c3 * u * u * u + c1 * u * u;
};

// Share of the duration over which opacity fades on custom-eased presets.
// Opacity must NOT follow a bounce/overshoot curve (it would flicker), so it
// ramps linearly over the first 30% instead.
export const CUSTOM_EASE_FADE_SHARE = 0.3;
